export const FLAPPY_WIDTH = 1280;
export const FLAPPY_HEIGHT = 720;

export const flappyConfig = {
  gravity: 1450,
  flapVelocity: -430,
  playerX: 240,
  playerY: 336,
  playerSize: 72,
  hitboxSize: 52,
  obstacleWidth: 92,
  obstacleGap: 220,
  obstacleSpeed: 300,
  spawnInterval: 1.6,
  groundY: 670,
} as const;
